import { matchPath } from 'react-router';
import { getPropertyAddress } from '@/utils/properties';
import routes from '../../../structure/routes';

/**
 * Locations that don't display bottom navigation
 * and add menu context button (mobile).
 * @type {string[]}
 */
export const fullscreenLocations = [
  'images',
  'add-room',
  'add-event',
  'add-document',
  'rooms/:roomId/edit',
  'rooms/:roomId/images',
  'events/:eventId/edit',
  'events/:eventId/images',
  'documents/:documentId/edit',
];

export const fullscreenPreviewModeLocations = ['documents/:documentId'];

/**
 * Locations where add button should be enabled
 * @type {string[]}
 */

export const locationsWithAddButtonEnabled = [
  'home/rooms',
  ...routes.map(({ path }) => path),
];

export const locationsPageTitles = (property) => {
  return {
    'personal-area/dashboard/home': 'Forside',
    'personal-area/dashboard/documents': 'Personlig område',
    'personal-area/dashboard/contract-templates': 'Kontrakter og maler',
    'dashboard/overview': 'Hjem',
    history: 'Hendelser',
    'personal-area/dashboard/boligmappa-plus': 'Oversikt Boligmappa+',
    condition: `Tilstand → Rapport for ${getPropertyAddress(property)}`,
    documents: 'Dokumenter',
    rooms: 'Rom',
    financials: 'Verdi & økonomi',
    '/more/find-professional': 'Finn håndverker',
    vendors: 'Leverandører',
    'more/account': 'Min profil',
    'more/private-share': 'Del din Boligmappe',
    notifications: 'Varsler',
  };
};

export const isFullScreenPreviewMode = (url, prefix) =>
  fullscreenPreviewModeLocations
    .map((location) => `${prefix}/${location}`)
    .some((location) =>
      matchPath(url, {
        path: location,
        exact: true,
      })
    );

export const isFullscreenMode = (url, prefix) =>
  fullscreenLocations
    .map((location) => `${prefix}/${location}`)
    .some((location) =>
      matchPath(url, {
        path: location,
        exact: true,
      })
    );
export const isAddButtonEnabled = (url, prefix) =>
  locationsWithAddButtonEnabled
    .map((location) => `${prefix}/${location}`)
    .some((location) =>
      matchPath(url, {
        path: location,
        exact: true,
      })
    );
